<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    fill="none"
    version="1.1"
    width="16"
    height="16"
    viewBox="0 0 16 16"
  >
    <g style="mix-blend-mode: passthrough">
      <g style="mix-blend-mode: passthrough">
        <path
          d="M13,2C13,2,13.71,0.71,13,0C13,0,8.66,5.07,8.66,5.07C8.66,5.07,9.71,6.39,9.71,6.39C9.71,6.39,13,2,13,2C13,2,13,2,13,2ZM13.07,10C12.65,10,12.25,10.09,11.89,10.26C11.89,10.26,3.31,0,3.31,0C2.62,0.71,3.31,2,3.31,2C3.31,2,6.99,7.02,6.99,7.02C6.99,7.02,4.22,10.26,4.22,10.26C3.84,10.09,3.43,10,3,10C1.34,10,0,11.34,0,13C0,14.66,1.34,16,3,16C4.66,16,6,14.66,6,13C6,12.54,5.89,12.11,5.71,11.73C5.71,11.73,8.1,8.54,8.1,8.54C8.1,8.54,10.43,11.73,10.43,11.73C10.25,12.12,10.14,12.55,10.14,13C10.14,14.66,11.45,16,13.07,16C14.69,16,16,14.66,16,13C16,11.34,14.69,10,13.07,10C13.07,10,13.07,10,13.07,10ZM3,14C2.45,14,2,13.55,2,13C2,12.45,2.45,12,3,12C3.55,12,4,12.45,4,13C4,13.55,3.55,14,3,14C3,14,3,14,3,14ZM13.07,14C12.53,14,12.09,13.55,12.09,13C12.09,12.45,12.53,12,13.07,12C13.61,12,14.05,12.45,14.05,13C14.05,13.55,13.61,14,13.07,14C13.07,14,13.07,14,13.07,14Z"
          fill-rule="evenodd"
          fill="currentColor"
        />
      </g>
    </g>
  </svg>
</template>
<script lang="ts">
import type { DefineComponent } from 'vue'
export default {
  name: 'Cut',
} as DefineComponent
</script>
